<template>
  <div class="sy-auto-number">
    <read-text :value='pureText' v-if='isPureText'></read-text>
    <el-input v-on="$listeners" type="input" v-bind="{...$props}" v-else></el-input>
  </div>
</template>

<script>
import { autoNumberProps, initValue } from './index'
export default {
  props: autoNumberProps,
  computed: {
    pureText () {
      const { isPureText, value } = this
      return isPureText ? initValue(value) : value
    }
  }
}
</script>
